
import { defineComponent, SetupContext, PropType, computed } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "SelectCategoryItem",
  props: {
    /**
     * インデックス
     */
    index: {
      type: Number,
      required: true
    },
    /**
     * 分類名
     */
    categoryName: {
      type: String,
      required: true
    },
    /**
     * 選択状態
     */
    isSelect: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("SelectCategoryItem setup start");
    NativeClient.sendDebugLog("SelectCategoryItem setup categoryName = " + props.categoryName + ", isSelect = " + props.isSelect);
  
    const selectCategory = () => {
      // getClientRectsは、スクロールによって変化するため、left, rightを使用する際は注意
      const elements = document.getElementsByClassName('select-category-item');
      const position = elements[props.index].getClientRects()
      NativeClient.sendDebugLog("SelectCategoryItem element position = " + JSON.stringify(position));
      context.emit("on-click", props.index, position[0].left, position[0].right, props.categoryName);
    };

    const styleTextColorSelected = computed (() => {
      if (props.isSelect) {
          NativeClient.sendDebugLog("SelectCategoryItem styleTextColorSelected select style");
          return { color: `#000000` };
      }
      NativeClient.sendDebugLog("SelectCategoryItem styleTextColorSelected not select style");
      return { color: `#707070` }; 
    });

    const styleOpacitySelected = computed (() => {
      NativeClient.sendDebugLog("SelectCategoryItem styleOpacitySelected");
      if (props.isSelect) {
        NativeClient.sendDebugLog("SelectCategoryItem tyleOpacitySelected selected color");
        return { opacity: 1.0 };
      }
      return { opacity: 0.0 };
    });

    return {
      selectCategory,
      styleTextColorSelected,
      styleOpacitySelected
    };
  }
});
